'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    txt: {
      position: 'relative',
      paddingTop: 17,
      paddingBottom: 21,
      color: theme.textField.color,
      '& input': {
        color: theme.textField.color,
        backgroundColor: 'transparent',
        padding: 0,
        position: 'relative',
        width: '100%',
        border: 'none',
        outline: 'none',
        height: '100%',
        boxSizing: 'border-box'
      },
      '&.hasLeftIcon $label': {
        transform: 'translate(24px, 0px)'
      },
      '&.selected $label': {
        color: theme.textField.selected.colorLabel,
        fontSize: theme.textField.selected.fontSizeLabel,
        transform: 'translate(0px, -19px)'
      },
      '&.selected $field': {
        color: theme.textField.selected.color,
        borderBottomColor: theme.textField.selected.borderColor
      },
      '&.focus $field': {
        borderBottomColor: theme.textField.active.borderColor
      },
      '&.focus $label': {
        color: theme.textField.active.colorLabel
      },
      '&.focus $helperText': {
        color: theme.textField.active.colorHelper
      },
      '&.error $field': {
        color: theme.textField.error.color,
        borderBottomColor: theme.textField.error.borderColor
      },
      '&.error $label': {
        color: theme.textField.error.colorLabel
      },
      '&.error $helperText': {
        color: theme.textField.error.colorHelper
      },
      '&.hidden': {
        display: 'none'
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      },
      '&$small': {
        paddingTop: 0
      },
      '&.bordered': {
        paddingTop: 17,
        '&.focus $field': {
          borderColor: theme.textField.active.borderColor
        },
        '&.error $field': {
          borderColor: theme.textField.error.borderColor
        },
        '& $field': {
          borderColor: theme.textField.borderColor,
          borderWidth: 1,
          borderStyle: 'solid'
        },
        '& $label': {
          transform: 'translate(0px, -22px)',
          fontSize: theme.textField.selected.fontSizeLabel
        },
        '&$small': {
          '& $field': {
            borderRadius: theme.textField.bordered.borderRadiusSmall,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 2,
            paddingBottom: 3
          }
        },
        '&$medium': {
          '& $field': {
            borderRadius: theme.textField.bordered.borderRadiusMedium,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 6,
            paddingBottom: 7
          }
        },
        '&$large': {
          '& $field': {
            borderRadius: theme.textField.bordered.borderRadiusLarge,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 10,
            paddingBottom: 11
          },
          '& $label': {
            transform: 'translate(0px, -27px)'
          },
          '& $helperText': {
            marginTop: 8
          }
        }
      }
    },
    field: {
      display: 'flex',
      borderBottomColor: theme.textField.borderColor,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      position: 'relative',
      padding: '4px 0 8px 0',
      transition: theme.transition(['all'])
    },
    label: {
      position: 'absolute',
      top: 19,
      zIndex: 1,
      transition: theme.transition(['all']),
      fontSize: theme.textField.fontSizeLabel,
      color: theme.textField.colorLabel,
      transform: 'translate(0px, 0px)',
      transformOrigin: 'left top 0px'
    },
    leftIcon: {
      marginRight: 8,
      marginBottom: 1,
      display: 'flex',
      alignItems: 'center'
    },
    rightIcon: {
      marginLeft: 24,
      marginBottom: 1,
      display: 'flex',
      alignItems: 'center'
    },
    helperText: {
      position: 'absolute',
      fontSize: theme.textField.fontSizeHelper,
      color: theme.textField.colorHelper,
      marginTop: 4
    },
    small: {
      '& input': {
        fontSize: theme.textField.fontSizeSmall
      }
    },
    medium: {
      '& input': {
        fontSize: theme.textField.fontSizeMedium
      },
      '& input::placeholder': {
        color: theme.textField.placeholder
      }
    },
    large: {
      '& input': {
        fontSize: theme.textField.fontSizeMedium
      },
      '& input::placeholder': {
        color: theme.textField.placeholder
      }
    },
    passIcon: {
      marginLeft: 24,
      marginBottom: 1,
      display: 'flex',
      alignSelf: 'center',
      cursor: 'pointer'
    },
    calendar: {
      position: 'absolute',
      top: 10,
      left: 0,
      zIndex: 9
    }
  };
};